import React, { useEffect, useState } from "react";
import { Caption, Frame, Img, ImgCont, Item } from "./styles";
import objectFitImages from "object-fit-images";
import Nav from "./Nav";
import { useWindowSize } from "@src/utils/useWindowSize";
import { AnimatePresence } from "framer-motion";
import { GatsbyImageProps } from "gatsby-plugin-image";

interface Props {
	images: {
		img:
			| React.ReactElement<HTMLImageElement>
			| React.FunctionComponent<GatsbyImageProps>;
		caption?: string;
	}[];
}

const Gallery: React.FC<Props> = (props) => {
	const { images } = props;
	const [activeItem, setActiveItem] = useState(0);
	const increment = () =>
		setActiveItem(activeItem == images.length - 1 ? 0 : activeItem + 1);
	const decrement = () =>
		setActiveItem(activeItem == 0 ? images.length - 1 : activeItem - 1);
	useEffect(() => {
		if (window) objectFitImages(Img);
	}, []);
	const windowSize = useWindowSize();
	return (
		<Frame windowSize={windowSize}>
			<Nav direction="prev" onClick={decrement} />
			<ImgCont windowSize={windowSize}>
				<AnimatePresence exitBeforeEnter>
					{images.reduce((acc: React.ReactNode[], val, index: number) => {
						if (activeItem == index) {
							acc.push(
								<Item
									key={`galleryItem${index}`}
									animate={{ opacity: 1 }}
									initial={{ opacity: 0 }}
									exit={{ opacity: 0 }}
								>
									<Img>{val.img}</Img>
									{val.caption && <Caption>{val.caption}</Caption>}
								</Item>
							);
						}
						return acc;
					}, [])}
				</AnimatePresence>
			</ImgCont>
			<Nav direction="next" onClick={increment} />
		</Frame>
	);
};

export default Gallery;
